import React, {FC} from 'react';
import {Key} from 'ts-key-enum';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../libs/shared/core/src/helpers/internationalization/message';
import {FrontKeyboardEvent} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {TextBox} from '../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {InlineEditingInputDisplay} from './inlineEditingInputDisplay';

/*
 * Props.
 */

interface InlineEditingTextBoxProps {
  value: string;
  onEdit: (arg: string) => void;
  onEditSave: (arg: string) => void;
  onEditCancel: () => void;
  shouldStartInEditMode?: boolean;
}

/*
 * Component.
 */

export const InlineEditingTextBox: FC<InlineEditingTextBoxProps> = (props) => {
  const {value, onEdit, onEditSave, onEditCancel, shouldStartInEditMode} = props;
  const localize = useLocalize();

  const onKeyDown = (event: FrontKeyboardEvent) => {
    switch (event.key) {
      case Key.Enter:
        event.preventDefault();
        onEditSave(value);
        break;

      case Key.Escape:
        event.preventDefault();
        onEditCancel();
        break;

      default:
      // Do nothing.
    }
  };

  return (
    <InlineEditingInputDisplay>
      <TextBox
        value={value}
        onChange={onEdit}
        onBlur={() => onEditSave(value)}
        onKeyDown={onKeyDown}
        shouldAutoFocus={shouldStartInEditMode}
        noMargin
        placeholder={localize(
          defineMessage({
            id: 'inline-editing-text-placeholder',
            message: 'Enter value',
          }),
        )}
      />
    </InlineEditingInputDisplay>
  );
};
